"use client";

import React from "react";

//Styles
import * as S from "./styles";
import { CheckbokInputProps } from "@/types";

const CheckboxComponent: React.FC<CheckbokInputProps> = ({
  className,
  label,
  labelLink,
  link,
  htmlFor,
  ...rest
}) => {
  return (
    <S.BoxCheckInput>
      <S.CheckInput type="checkbox" id={htmlFor} {...rest} />
      <S.LabelCheck htmlFor={htmlFor}>
        {label}{" "}
        <S.LinkLabel href={link} target="_blank" rel="noopener noreferrer">
          {labelLink}
        </S.LinkLabel>
      </S.LabelCheck>
    </S.BoxCheckInput>
  );
};

export default CheckboxComponent;
